import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import { faAlarmExclamation } from "@fortawesome/pro-solid-svg-icons/faAlarmExclamation";
import { faBook } from "@fortawesome/pro-solid-svg-icons/faBook";
import { faBusinessTime } from "@fortawesome/pro-solid-svg-icons/faBusinessTime";
import { faCalendarCheck } from "@fortawesome/pro-solid-svg-icons/faCalendarCheck";
import { faCar } from "@fortawesome/pro-solid-svg-icons/faCar";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { faExclamation } from "@fortawesome/pro-solid-svg-icons/faExclamation";
import { faFileAlt } from "@fortawesome/pro-solid-svg-icons/faFileAlt";
import { faFolder } from "@fortawesome/pro-solid-svg-icons/faFolder";
import { faGraduationCap } from "@fortawesome/pro-solid-svg-icons/faGraduationCap";
import { faLayerGroup } from "@fortawesome/pro-solid-svg-icons/faLayerGroup";
import { faLink } from "@fortawesome/pro-solid-svg-icons/faLink";
import { faRoute } from "@fortawesome/pro-solid-svg-icons/faRoute";
import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";

import MmcNotificationAction from "@app/enum/MmcNotificationAction";
import MmcNotification from "@app/types/MmcNotification";

const getActionIcon = (
  action: MmcNotificationAction,
  notification: MmcNotification
): IconProp | undefined => {
  switch (action) {
    case MmcNotificationAction.ACTIVITY_STARTING:
    case MmcNotificationAction.COACHING_TASK_OVERDUE:
    case MmcNotificationAction.INCOMPLETE_ACTIVITY:
    case MmcNotificationAction.MARK_ACTIVITY_AS_DONE:
      return faCalendarCheck;
    case MmcNotificationAction.AUTO_TRACKED_TRIPS:
      return !notification.count ? faExclamation : faCar;
    case MmcNotificationAction.BOUNCED_EMAIL:
      return faEnvelope;
    case MmcNotificationAction.COACHING_NOTE_CREATED:
    case MmcNotificationAction.COACHING_NOTE_REPLIED:
    case MmcNotificationAction.COACHING_TASK_ASSIGNED:
    case MmcNotificationAction.COACHING_TASK_COMPLETED:
    case MmcNotificationAction.COACHING_TASK_CREATED:
    case MmcNotificationAction.COACHING_TASK_MENTIONED:
      return faGraduationCap;
    case MmcNotificationAction.COMPANY_GROUP_SHARED:
    case MmcNotificationAction.DEAL_GROUP_SHARED:
    case MmcNotificationAction.PEOPLE_GROUP_SHARED:
      return faLayerGroup;
    case MmcNotificationAction.COMPANY_ROUTE_SHARED:
    case MmcNotificationAction.PEOPLE_ROUTE_SHARED:
    case MmcNotificationAction.UNIFIED_ROUTE_SHARED:
      return faRoute;
    case MmcNotificationAction.DEALS_MARKED_LOST:
      return faTimes;
    case MmcNotificationAction.DEALS_MARKED_WON:
      return faCheck;
    case MmcNotificationAction.DEALS_ROTTING:
      return faBusinessTime;
    case MmcNotificationAction.EMAIL_TEMPLATE_SHARED:
    case MmcNotificationAction.RESOURCE_SHARED:
      return notification.url ? faLink : faFileAlt;
    case MmcNotificationAction.FEATURE_REQUESTED:
    case MmcNotificationAction.SAVED_FILTER_SHARED:
      return faFilter;
    case MmcNotificationAction.FOLDER_SHARED:
      return faFolder;
    case MmcNotificationAction.GUIDE_ASSIGNED:
    case MmcNotificationAction.GUIDE_REMINDER:
      return faBook;
    case MmcNotificationAction.OUT_OF_CADENCE:
      return faAlarmExclamation;
    case MmcNotificationAction.OVERDUE_ACTIVITIES:
    case MmcNotificationAction.UNCLASSIFIED_TRIPS:
      return faExclamation;
  }
};

export default getActionIcon;
